import { createQueryKeys } from '@lukemorales/query-key-factory';

import { getPortDirectory } from '../clients/additionalData.api';
import { getPorts } from '../clients/port.api';
import type { GetPortsParams } from '../clients/port.api';

interface PortDetailComboBoxOptionsParams {
    cacheKey: string;
    searchQuery: string;
}

export const ports = createQueryKeys('ports', {
    detail: (id: string) => ({
        queryKey: [id],
        queryFn: () => getPorts({ ids: [id] }),
    }),
    pagination: (params: GetPortsParams) => ({
        queryKey: [{ params }],
        queryFn: () => getPorts(params),
    }),
    comboBoxOptions: (params: GetPortsParams) => ({
        queryKey: [{ params }],
    }),
    paginatedComboBoxOptions: (params: GetPortsParams) => ({
        queryKey: [{ params }],
    }),
    detailComboBoxOptions: (params: PortDetailComboBoxOptionsParams) => ({ queryKey: [{ params }] }),
    selectedDetailComboBoxOption: (portId: string, cacheKey: string) => ({ queryKey: [{ portId, cacheKey }] }),
    directories: (portId: string, supplierGroupId: string) => ({
        queryKey: [{ portId, supplierGroupId }],
        queryFn: () => getPortDirectory({ portId, supplierGroupId }),
    }),
});
